import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";
import { BottomTabNav } from "./BottomTabNav";

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      
      {/* Main content area with padding for fixed header and bottom nav */}
      <main className="pt-14 pb-16 safe-area-pt safe-area-pb">
        <div className="min-h-[calc(100vh-3.5rem-4rem)]">
          {children}
        </div>
      </main>
      
      <BottomTabNav />
    </div>
  );
};
